import { graphql, Link } from "gatsby"
import * as React from "react"
// import Layout from "../layouts"

import '../assets/all.css'
import './greensPlatformButton.css'
import '../../static/font-awesome-4.7.0/css/font-awesome.css'

import mainImage from "../assets/1024px-Cammeray_Tunks_Park-cropped.jpg"
import logoImage from "../assets/Greens_logo-300px.png"
import donateImage from "../assets/Donate.jpg"
import volunterImage from "../assets/OurVolunteers.jpg"
import { SectionTitle } from "../components/SectionTitle";
import { CardContainer2 } from "../components/Cards";
import { OurCandidates } from "../components/OurCandidates";
import { QandAsegment } from "../components/QandAsegment";
import { Head } from "../components/Head";
import { FeedbackButton } from "../components/Feedback";
import { LanguageButtons } from "../components/LanguageButtons";
import { Authorisation } from "../components/Authorisation";
import { LargeButton } from "../components/LargeButton";

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  pageContext: {
    lang: string
  },
  data: {
    site: {
      siteMetadata: {
        siteName: string
      }
    }
    ourPriorities: {
      edges: {
        node: {
          id: string
          html: string
          frontmatter: {
            lang: string
            heading: string
          }
        }
      }[]
    }
    FAQs: {
      edges: {
        node: {
          id: string
          html: string
          frontmatter: {
            title: string
            path: string
            lang?: string
          }
        }
      }[]
    }
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        siteName
      }
    }
    ourPriorities: allMarkdownRemark (filter: {fileAbsolutePath: {regex: "/our-priorities/"}}) {
      edges {
        node {
          id
          html
          fileAbsolutePath
          frontmatter {
            lang
            heading
          }
        }
      }
    }
    FAQs: allMarkdownRemark (filter: {fileAbsolutePath: {regex: "/FAQ/"}}) {
      edges {
        node {
          id
          html
          fileAbsolutePath
          frontmatter {
            title
            path
            lang
          }
        }
      }
    }
  }
`

const translations = {
  helpOurCampaign: {
    en: "Help our campaign",
    zh: "帮助我们的活动",
  },
  donate: {
    en: "Donate",
    zh: "捐",
  },
  volunteer: {
    en: "Volunteer",
    zh: "志愿者",
  },
  joinOurTeam: {
    en: "Join our team",
    zh: "加入我们的团队",
  },
  followUs: {
    en: "Social Media",
    zh: "社交媒体",
  },
  followUsOnFacebook: {
    en: "Follow us on Facebook",
    zh: "在Facebook上关注我们",
  }
}
type TextStrings<T> = {
  [P in keyof T]: string
}
const donateToOurCampaign = (name: string) => ({
  en: `Donate to our ${name} campaign`,
  zh: `捐赠给我们的${name}活动`
})

function getTexts(lang: string) {
  const output: any = {}

  for (const k of Object.keys(translations)) {
    output[k] = (translations as any)[k][lang]
  }

  return output as TextStrings<typeof translations>
}

export default class IndexPage extends React.Component<IndexPageProps, {}> {
  public render() {
    const { siteName } = this.props.data.site.siteMetadata

    // const langMatch = (typeof window === 'object') && location.search.match(/lang=(.+)/)
    // const lang = (langMatch && langMatch[1]) || "en"
    const lang = this.props.pageContext.lang || "en"

    const subHeaderText =
      lang === "zh"
      ? "投票支持绿党， 你便能对我们社会面临的最重要的问题产生积极影响" // manual translation
      : "Vote for the Greens to make a positive impact on the most important issues facing our society"

    const qAndAText =
      lang === "zh"
      ? "问答"
      : "Q & A"

    const texts = getTexts(lang)

    const ourPriorities =
      this.props.data.ourPriorities.edges
        .filter(e => e.node.frontmatter.lang === lang)
      [0].node

    const ourPrioritiesHtml = ourPriorities.html
    const ourPrioritiesHeading = ourPriorities.frontmatter.heading

    const faqs =
      this.props.data.FAQs.edges
        .filter(a => (a.node.frontmatter.lang || "en") === lang)

    return (
      <main role="main" className="main">
        <Head />
        <LanguageButtons currentLanguage={lang} />
        <FeedbackButton />

        <div className="hero-image__wrapper">

          <div className="hero-image"
            style={{ backgroundImage: `url(${mainImage})`, backgroundPositionY: '25%' }}
            title="Tunks Park, Northbridge &amp; Cammeray, by Jim Bar. Published at Wikimedia Commons. Used under Creative Commons Attribution 3.0 license with thanks."
          >
            <div className="hero-image__heading">
              <div className="container">
                <div className="hero-image-title__overflow">
                  <div className="hero-image-title__wrapper">
                    <h1 className="hero-image-title">Lower North Shore Greens</h1>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="hero-sub-section">
          <div className="container">
            <div className="hero-sub-section-content" style={{display: "flex"}}>
              <p style={{ width: "60%" }}>
                {subHeaderText}
              </p>
                {/* <img
                  src={logoImage}
                  style={{
                    height: "80px",
                    float: "right",
                  }}
                /> */}
            </div>
          </div>
        </div>

        <a id="main-content"></a>

        <div className="layout-content page-main page-main--triangles">
          <article role="article" className="node node--type-person node--view-mode-full">

            <div className="node__content">
              <div className="container">

                <SectionTitle title={ourPrioritiesHeading} />
                <div style={{ fontSize: "1.5em" }} dangerouslySetInnerHTML={{ __html: ourPrioritiesHtml }} />

                <div className="greensPlatformButtonContainer">
                  <div className="greensPlatformButtonBorder">
                    <LargeButton
                        href="https://greens.org.au/nsw/platform"
                        className="greensPlatformButton"
                        line1="Click here for the full Greens NSW Election Platform"
                    />
                  </div>
                </div>

                <SectionTitle title="Our Candidates" /><br />
                <OurCandidates />


                { faqs.length > 0 &&
                  <SectionTitle title={qAndAText} />
                }
                <div style={{ fontSize: "1.5em" }}>
                  {faqs
                    .sort((a, b) => a.node.frontmatter.path.localeCompare(b.node.frontmatter.path))
                    .map(faq => (
                      <QandAsegment
                        key={faq.node.id}
                        title={faq.node.frontmatter.title}
                        html={faq.node.html}
                      />
                    ))}
                </div>

                {/* <PersonalIntro /> */}


              </div>

              <SectionTitle title={texts.helpOurCampaign} /><br />

              <CardContainer2
                cards={[
                  {
                    imageUrl: donateImage,
                    title: texts.donate,
                    buttons: [
                      {
                        text: donateToOurCampaign("Lane Cove").en,
                        url: "https://contact-nsw.greens.org.au/civicrm/contribute/transact?id=2169&amp;reset=1",
                      },
                      {
                        text: donateToOurCampaign("North Shore").en,
                        url: "https://contact-nsw.greens.org.au/civicrm/contribute/transact?id=2272&amp;reset=1",
                      },
                      {
                        text: donateToOurCampaign("Willoughby").en,
                        url: "https://contact-nsw.greens.org.au/civicrm/contribute/transact?id=2289&amp;reset=1",
                      },
                    ],
                  },
                  {
                    imageUrl: volunterImage,
                    title: texts.volunteer,
                    buttons: [{
                      text: texts.joinOurTeam,
                      url: "https://greens.org.au/nsw/volunteer",
                    }],
                  },
                  {
                    imageUrl: volunterImage,
                    title: texts.followUs,
                    buttons: [{
                      text: texts.followUsOnFacebook,
                      url: "https://www.facebook.com/lnsg.northshore/",
                    }],
                  },
                ]}
              />
            </div>

            <Authorisation />
            <div className="footer-logo-container">
              <img
                src={logoImage}
                className="footer-logo-image"
              />
            </div>

          </article>
        </div>


      </main>
    )
  }
}